<template>
  <div id="app">
    <router-view/>
    <Navbar/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>

<style lang="scss">
@import "scss/_vars.scss";
@import "scss/_mixins.scss";

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  background-color: #fff;
}
body {
  background-color: #fff;
  margin: 0;
}
</style>
